import { APP_NAME } from '@tsgecart/config';

/**
 * Rendered instead of the entire app tree when VITE_CLERK_PUBLISHABLE_KEY
 * is absent (see App.tsx) -- every route in this app either needs Clerk
 * loaded (auth pages, guarded pages) or renders auth-aware UI (the header),
 * so there is no safe partial app to fall back to. Fails loudly and
 * legibly here rather than letting `useAuth()`/`useUser()` throw an opaque
 * "must be used within <ClerkProvider>" error somewhere deep in the tree.
 */
export function ClerkNotConfiguredPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 bg-white p-8 text-center">
      <h1 className="text-2xl font-semibold text-gray-900">{APP_NAME}</h1>
      <p className="max-w-md text-gray-500">
        Authentication is not configured for this environment. Set{' '}
        <code className="rounded bg-gray-100 px-1.5 py-0.5 text-sm">
          VITE_CLERK_PUBLISHABLE_KEY
        </code>{' '}
        and reload.
      </p>
    </main>
  );
}
